import React, { useRef } from 'react';
import { ReactComponent as UploadIcon } from "assets/img/svg/upload.svg";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";

const CustomUpload = ({
    fileData,
    setFileData,
    type = "file",
    accept = ".jpg, .jpeg, .png, .pdf, .zip, .docx , .xlsx, .svg",
    inputStyle = { display: "none" },
    uploadLabel = "Upload",
    id = "cus-file",
}) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        try {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.readAsDataURL(file);
            const fileExtension = file.name.split('.').pop().toLowerCase();
            reader.onload = () => {
                setFileData({
                    attachment: reader.result.split(",")[1],
                    fileName: file.name,
                    fileExtension: fileExtension,
                });
            };

            reader.onerror = (error) => {
                console.error('File reading error:', error);
            };
        } catch (error) {
            console.error('Unexpected error during file upload:', error);
        }
    };
    const handleClear = () => setFileData(null);
    return (
        <div className="d-flex align-items-center gap-md">
            <label
                htmlFor={id}
                className={fileData?.fileName ? "" : "upload-btn"}
                style={{ cursor: "pointer" }}
            >
                <UploadIcon /> {fileData?.fileName ?? uploadLabel}
            </label>
            <input
                id={id}
                ref={fileInputRef}
                type={type}
                accept={accept}
                style={inputStyle}
                onChange={handleFileChange}
            />
            {fileData?.fileName && (
                <CloseIcon
                    className="cursor"
                    style={{ width: "33px", height: "33px" }}
                    onClick={handleClear}
                />
            )}
        </div>
    );
};

export default CustomUpload;
